import React, { useEffect } from 'react';
import { Helmet } from 'react-helmet-async';

const WATERCRAFT_FAVICON = `${process.env.PUBLIC_URL}/watercraft-favicon.png`;

/**
 * Sets the browser-tab title and favicon for watercraft routes.
 */
export default function WatercraftHelmet(): React.JSX.Element {
  useEffect(() => {
    const link = document.querySelector<HTMLLinkElement>("link[rel~='icon']");
    if (!link) {
      return;
    }
    const previousHref = link.getAttribute('href');
    const previousType = link.getAttribute('type');
    link.setAttribute('type', 'image/png');
    link.setAttribute('href', WATERCRAFT_FAVICON);

    // On Unmount -> revert to previous
    return () => {
      if (previousHref) {
        link.setAttribute('href', previousHref);
      }
      if (previousType) {
        link.setAttribute('type', previousType);
      } else {
        link.removeAttribute('type');
      }
    };
  }, []);

  return (
    <Helmet>
      <title>watercraft</title>
    </Helmet>
  );
}
